import React from "react";
import {
  IconButton,
  Badge,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
  Box,
  Container,
  Drawer,
} from "@mui/material";
import { IoIosNotificationsOutline } from "react-icons/io";
import { useAuth } from "shared/providers/auth";
import { INotification } from "shared/types/Notification";
import { ReturnButton } from "components/ReturnButton";

import * as Styled from "./styles";

const Notification: React.FC = () => {
  const { notifications, markNotificationRead } = useAuth();
  const [selectedNotification, setSelectedNotification] =
    React.useState<INotification | null>(null);
  const [open, setOpen] = React.useState<boolean>(false);

  const handleNotificationClick = (notification: INotification) => {
    setSelectedNotification(notification);
    markNotificationRead(notification.id);
  };

  const handleCloseDialog = () => {
    setSelectedNotification(null);
  };

  const unreadCount = notifications.filter((n) => n.is_lido === 0).length;

  const formatDateTime = (dateTimeString: string): string => {
    const dateTime: Date = new Date(dateTimeString);
    const options: Intl.DateTimeFormatOptions = {
      weekday: "long",
      year: "numeric",
      month: "long",
      day: "numeric",
      hour: "numeric",
      minute: "numeric",
    };

    const formattedDateTime: string = dateTime.toLocaleDateString(
      "pt-BR",
      options
    );

    const today: Date = new Date();

    // Verifica se a data é hoje
    if (dateTime.toDateString() === today.toDateString()) {
      return `${formattedDateTime.split("às")[1]}`;
    }

    // Para outras datas
    else {
      const date = new Date(dateTime);
      const day = String(date.getDate()).padStart(2, "0");
      const month = String(date.getMonth() + 1).padStart(2, "0");
      return `${day}/${month}`;
    }
  };

  const limitText = (text: string, limit: number): string => {
    return text.length > limit ? text.slice(0, limit) + "..." : text;
  };

  return (
    <Styled.Box>
      <IconButton onClick={() => setOpen(true)} sx={{ paddingTop: "0" }}>
        <Badge color="error" variant="dot" invisible={unreadCount === 0}>
          <IoIosNotificationsOutline size={30} />
        </Badge>
      </IconButton>

      <Drawer open={open} onClose={() => setOpen(false)} anchor="right">
        <Box sx={{ backgroundColor: "white", height: "100%", width: "100%" }}>
          <Container>
            <ReturnButton
              title="Notificações"
              onClick={() => {
                setOpen(false);
              }}
            />
            {notifications.length === 0 ? (
              <Styled.Item>Nenhuma notificação</Styled.Item>
            ) : (
              notifications.map((notification) => (
                <Styled.Item
                  key={notification.id}
                  onClick={() => handleNotificationClick(notification)}
                  style={{
                    fontWeight: notification.is_lido === 0 ? "bold" : "normal",
                  }}
                  $isNew={notification.is_lido === 0}
                >
                  <Styled.Date>
                    {formatDateTime(notification.data_cadastro)}
                  </Styled.Date>
                  <h6>{notification.titulo}</h6>
                  <p>{limitText(notification.mensagem, 30)}</p>
                </Styled.Item>
              ))
            )}
          </Container>
        </Box>
      </Drawer>

      <Dialog
        open={!!selectedNotification}
        onClose={handleCloseDialog}
        sx={{
          "& .MuiDialog-paper": { width: "400px !important", maxWidth: "none" },
          zIndex: 2000,
        }}
      >
        <DialogTitle>{selectedNotification?.titulo}</DialogTitle>
        <DialogContent>
          <DialogContentText component="div">
            {selectedNotification?.mensagem}
          </DialogContentText>
          <DialogActions
            sx={{
              display: "flex",
              justifyContent: "center",
              marginTop: "20px",
            }}
          >
            <Button
              variant="contained"
              color="primary"
              onClick={handleCloseDialog}
            >
              Fechar
            </Button>
          </DialogActions>
        </DialogContent>
      </Dialog>
    </Styled.Box>
  );
};

export { Notification };
